import { render, staticRenderFns } from "./webSiteCreate.vue?vue&type=template&id=5f2d5866&scoped=true"
import script from "./webSiteCreate.vue?vue&type=script&lang=js"
export * from "./webSiteCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d5866",
  null
  
)

export default component.exports